import AxiosUser from './axios_manage_point_api'

const ModuleManagePoint = {
  state: {
    // User Detail Page
    stateCreatePointSet: [],
    stateEditSellerShopPoint: [],
    stategetListUserPointByUserID: [],
    stategetSellerShopPointDetail: [],
    stategetDetailUserPointByUser: [],
    stagegetListPointRedeem: [],
    stagegetProductListPointRedeem: [],
    stagegetDetailPointRedeem: [],
    stagecreatePointRedeem: [],
    stagecheckPointRedeem: [],
    stageupdatePointRedeem: [],
    stagedeletePointRedeem: [],
    stageupdateStatusPointRedeem: [],
    stageupdateSettingPointRedeem: []
  },
  mutations: {
    // User Detail Page
    mutationsCreatePointSet (state, data) {
      state.stateCreatePointSet = data
    },
    mutationsEditSellerShopPoint (state, data) {
      state.stateEditSellerShopPoint = data
    },
    mutationsgetListUserPointByUserID (state, data) {
      state.stategetListUserPointByUserID = data
    },
    mutationsgetSellerShopPointDetail (state, data) {
      state.stategetSellerShopPointDetail = data
    },
    mutationsgetDetailUserPointByUser (state, data) {
      state.stategetDetailUserPointByUser = data
    },
    mutationsgetListPointRedeem (state, data) {
      state.stagegetListPointRedeem = data
    },
    mutationsgetProductListPointRedeem (state, data) {
      state.stagegetProductListPointRedeem = data
    },
    mutationsgetDetailPointRedeem (state, data) {
      state.stagegetDetailPointRedeem = data
    },
    mutationscreatePointRedeem (state, data) {
      state.stagecreatePointRedeem = data
    },
    mutationscheckPointRedeem (state, data) {
      state.stagecheckPointRedeem = data
    },
    mutationsupdatePointRedeem (state, data) {
      state.stageupdatePointRedeem = data
    },
    mutationsdeletePointRedeem (state, data) {
      state.stagedeletePointRedeem = data
    },
    mutationsupdateStatusPointRedeem (state, data) {
      state.stageupdateStatusPointRedeem = data
    },
    mutationsupdateSettingPointRedeem (state, data) {
      state.stageupdateSettingPointRedeem = data
    }
  },
  actions: {
    // User Detail Page
    async actionsCreatePointSet (context, access) {
      const responseData = await AxiosUser.CreatePointSet(access)
      // console.log('response', responseData)
      await context.commit('mutationsCreatePointSet', responseData)
    },
    async actionsEditSellerShopPoint (context, access) {
      const responseData = await AxiosUser.EditSellerShopPoint(access)
      // console.log('response', responseData)
      await context.commit('mutationsEditSellerShopPoint', responseData)
    },
    async actionsgetListUserPointByUserID (context, access) {
      const responseData = await AxiosUser.getListUserPointByUserID(access)
      // console.log('response', responseData)
      await context.commit('mutationsgetListUserPointByUserID', responseData)
    },
    async actionsgetSellerShopPointDetail (context, access) {
      const responseData = await AxiosUser.getSellerShopPointDetail(access)
      // console.log('response', responseData)
      await context.commit('mutationsgetSellerShopPointDetail', responseData)
    },
    async actionsgetDetailUserPointByUser (context, access) {
      const responseData = await AxiosUser.getDetailUserPointByUser(access)
      // console.log('response', responseData)
      await context.commit('mutationsgetDetailUserPointByUser', responseData)
    },
    async actionsgetListPointRedeem (context, access) {
      const responseData = await AxiosUser.getListPointRedeem(access)
      await context.commit('mutationsgetListPointRedeem', responseData)
    },
    async actionsgetProductListPointRedeem (context, access) {
      const responseData = await AxiosUser.getProductListPointRedeem(access)
      await context.commit('mutationsgetProductListPointRedeem', responseData)
    },
    async actionsgetDetailPointRedeem (context, access) {
      const responseData = await AxiosUser.getDetailPointRedeem(access)
      await context.commit('mutationsgetDetailPointRedeem', responseData)
    },
    async actionscreatePointRedeem (context, access) {
      const responseData = await AxiosUser.createPointRedeem(access)
      await context.commit('mutationscreatePointRedeem', responseData)
    },
    async actionscheckPointRedeem (context, access) {
      const responseData = await AxiosUser.checkPointRedeem(access)
      await context.commit('mutationscheckPointRedeem', responseData)
      return responseData
    },
    async actionsupdatePointRedeem (context, access) {
      const responseData = await AxiosUser.updatePointRedeem(access)
      await context.commit('mutationsupdatePointRedeem', responseData)
    },
    async actionsdeletePointRedeem (context, access) {
      const responseData = await AxiosUser.deletePointRedeem(access)
      await context.commit('mutationsdeletePointRedeem', responseData)
    },
    async actionsupdateStatusPointRedeem (context, access) {
      const responseData = await AxiosUser.updateStatusPointRedeem(access)
      await context.commit('mutationsupdateStatusPointRedeem', responseData)
    },
    async actionsupdateSettingPointRedeem (context, access) {
      const responseData = await AxiosUser.updateSettingPointRedeem(access)
      await context.commit('mutationsupdateSettingPointRedeem', responseData)
    }
  }
}
export default ModuleManagePoint
